export enum SampleFields {
  GestationAge = 'GestationAge',
  UltrasoundDate = 'UltrasoundDate',
  SampleType = 'SampleType',
  HeparinTherapy = 'HeparinTherapy',
  HumanSerumAlbuminTherapy = 'HumanSerumAlbuminTherapy',
  CellularImmunotherapy = 'CellularImmunotherapy',
  StemCellTherapy = 'StemCellTherapy',
  TransplantSurgery = 'TransplantSurgery',
  BloodTransfusion = 'BloodTransfusion',
  PriorScreeningTest = 'PriorScreeningTest',
  EditFieldsAvailable = 'EditFieldsAvailable',
  Participant = 'Participant',
}
